import {
  AddManagerToChurchInput,
  AddManagerToChurchOutput,
  BaptizeAmerica,
  CreateAdminUserInput,
  CreateAdminUserOutput,
  CreateAttendeeUserInput,
  CreateAttendeeUserOutput,
  CreateBaptismInput,
  CreateBaptismOutput,
  CreateChurchInput,
  CreateChurchInvitationInput,
  CreateChurchInvitationOutput,
  CreateChurchOutput,
  CreateRegistrationInput,
  CreateRegistrationOutput,
  DeleteBaptismInput,
  DeleteBaptismOutput,
  DeleteChurchInput,
  DeleteChurchOutput,
  DeleteCurrentUserOutput,
  DeleteInvitationInput,
  DeleteInvitationOutput,
  DeleteRegistrationInput,
  DeleteRegistrationOutput,
  DeleteUserInput,
  DeleteUserOutput,
  GetBaptismInput,
  GetBaptismOutput,
  GetChurchInput,
  GetChurchManagerInput,
  GetChurchManagerOutput,
  GetChurchOutput,
  GetUserInput,
  GetUserOutput,
  ListBaptismInput,
  ListBaptismOutput,
  ListChurchInput,
  ListChurchOutput,
  ListCurrentUserRegistrationInput,
  ListCurrentUserRegistrationOutput,
  ListInvitationOutput,
  LoadDashboardInput,
  LoadDashboardOutput,
  RemoveManagerFromChurchInput,
  RemoveManagerFromChurchOutput,
  SummarizeUsersOutput,
  UpdateAnalyticsInput,
  UpdateAnalyticsOutput,
  UpdateBaptismInput,
  UpdateBaptismOutput,
  UpdateChurchInput,
  UpdateChurchOutput,
} from "baptize-america-client";
import { IdentityProvider } from "@smithy/types/dist-types/identity/identity";
import { TokenIdentity } from "@smithy/types/dist-types/identity/tokenIdentity";
import { configMap } from "./helper";
import { fetchAuthSession, signOut } from "aws-amplify/auth";

const baseUrl = configMap[window.location.hostname].baseUrl;

const noAuthClient = new BaptizeAmerica({
  endpoint: baseUrl,
  region: "us-west-2",
});

const tokenProvider: IdentityProvider<TokenIdentity> = async () => {
  try {
    const session = await fetchAuthSession();
    return Promise.resolve({
      token: session.tokens?.idToken?.toString()!,
      expiration: new Date(session.tokens!!.idToken!!.payload!!.exp!! * 1000),
    });
  } catch (error) {
    console.error("Error fetching the current session:", error);
    await signOut();
    return Promise.reject(new Error("Failed to fetch session token."));
  }
};

const client = new BaptizeAmerica({
  endpoint: baseUrl,
  region: "us-west-2",
  token: tokenProvider,
});

export const createAdminUser = (
  input: CreateAdminUserInput,
): Promise<CreateAdminUserOutput> => {
  return client.createAdminUser(input);
};

export const createChurchInvitation = (
  input: CreateChurchInvitationInput,
): Promise<CreateChurchInvitationOutput> => {
  return client.createChurchInvitation(input);
};

export const deleteCurrentUser = (): Promise<DeleteCurrentUserOutput> => {
  return client.deleteCurrentUser();
};

export const listChurch = (
  input: ListChurchInput,
): Promise<ListChurchOutput> => {
  return noAuthClient.listChurch(input);
};

export const createChurch = (
  input: CreateChurchInput,
): Promise<CreateChurchOutput> => {
  return noAuthClient.createChurch(input);
};

export const updateChurch = (
  input: UpdateChurchInput,
): Promise<UpdateChurchOutput> => {
  return client.updateChurch(input);
};

export const addManagerToChurch = (
  input: AddManagerToChurchInput,
): Promise<AddManagerToChurchOutput> => {
  return client.addManagerToChurch(input);
};

export const removeManagerFromChurch = (
  input: RemoveManagerFromChurchInput,
): Promise<RemoveManagerFromChurchOutput> => {
  return client.removeManagerFromChurch(input);
};

export const getChurch = (input: GetChurchInput): Promise<GetChurchOutput> => {
  return noAuthClient.getChurch(input);
};

export const getChurchManagers = (
  input: GetChurchManagerInput,
): Promise<GetChurchManagerOutput> => {
  return client.getChurchManager(input);
};

export const deleteChurch = (
  input: DeleteChurchInput,
): Promise<DeleteChurchOutput> => {
  return client.deleteChurch(input);
};

export const createBaptism = (
  input: CreateBaptismInput,
): Promise<CreateBaptismOutput> => {
  return client.createBaptism(input);
};

export const updateBaptism = (
  input: UpdateBaptismInput,
): Promise<UpdateBaptismOutput> => {
  return client.updateBaptism(input);
};

export const deleteBaptism = (
  input: DeleteBaptismInput,
): Promise<DeleteBaptismOutput> => {
  return client.deleteBaptism(input);
};

export const listBaptism = (
  input: ListBaptismInput,
): Promise<ListBaptismOutput> => {
  return noAuthClient.listBaptism(input);
};

export const getBaptism = (
  input: GetBaptismInput,
): Promise<GetBaptismOutput> => {
  return client.getBaptism(input);
};

export const createRegistration = (
  input: CreateRegistrationInput,
): Promise<CreateRegistrationOutput> => {
  return client.createRegistration(input);
};

export const deleteRegistration = (
  input: DeleteRegistrationInput,
): Promise<DeleteRegistrationOutput> => {
  return client.deleteRegistration(input);
};

export const listCurrentUserRegistration = (
  input: ListCurrentUserRegistrationInput,
): Promise<ListCurrentUserRegistrationOutput> => {
  return client.listCurrentUserRegistration(input);
};

export const createAttendeeUser = (
  input: CreateAttendeeUserInput,
): Promise<CreateAttendeeUserOutput> => {
  return client.createAttendeeUser(input);
};

export const loadDashboard = (
  input: LoadDashboardInput,
): Promise<LoadDashboardOutput> => {
  return client.loadDashboard(input);
};

export const listInvitation = (): Promise<ListInvitationOutput> => {
  return client.listInvitation();
};

export const deleteInvitation = (
  input: DeleteInvitationInput,
): Promise<DeleteInvitationOutput> => {
  return client.deleteInvitation(input);
};

export const updateAnalytics = (
  input: UpdateAnalyticsInput,
): Promise<UpdateAnalyticsOutput> => {
  return noAuthClient.updateAnalytics(input);
};

export const summarizeUsers = (): Promise<SummarizeUsersOutput> => {
  return client.summarizeUsers();
};

export const getUser = (input: GetUserInput): Promise<GetUserOutput> => {
  return client.getUser(input);
};

export const deleteUser = (
  input: DeleteUserInput,
): Promise<DeleteUserOutput> => {
  return client.deleteUser(input);
};
